import React, { useState } from "react";
import { isEmail } from "validator";
import { MailingListService } from "../services";

// Cream-band call-to-action sitting above the dark footer. Uses the
// existing MailingListService.create endpoint; success/error feedback is
// inlined in the strip so the user doesn't need to scroll to a toast.
const NewsletterStrip: React.FC = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    if (!email || !isEmail(email)) {
      setIsError(true);
      setMessage("Please enter a valid email address.");
      return;
    }
    setSubmitting(true);
    setMessage("");
    setIsError(false);
    const result = await MailingListService.create({ email });
    setSubmitting(false);
    if (result?.error) {
      setIsError(true);
      setMessage(result.error);
      return;
    }
    setIsError(false);
    setMessage("You're on the list. Thanks for subscribing.");
    setEmail("");
  };

  return (
    <section className="newsletterStrip">
      <div className="container">
        <div className="newsletterStrip__inner">
          <div className="newsletterStrip__copy">
            <span className="newsletterStrip__eyebrow">Stay close</span>
            <h3 className="newsletterStrip__heading">
              New art, new auctions, every week.
            </h3>
            <p className="newsletterStrip__subtitle">
              Join our mailing list to stay updated with our endeavours.
            </p>
          </div>
          <form className="newsletterStrip__form" onSubmit={handleSubmit}>
            <div className="newsletterStrip__row">
              <input
                className="newsletterStrip__input"
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (message) setMessage("");
                }}
                aria-label="Email address"
              />
              <button
                type="submit"
                className="newsletterStrip__submit"
                disabled={submitting}
              >
                {submitting ? "…" : "Subscribe"}
              </button>
            </div>
            <div
              className={`newsletterStrip__message ${
                message
                  ? isError
                    ? "newsletterStrip__message--error"
                    : "newsletterStrip__message--success"
                  : ""
              }`}
            >
              {message}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterStrip;
